export default "__VITE_ASSET__vtVtTj01__"